__webpack_require__.p = "/image-detector/";